import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { AppConsts } from './AppConsts';
@Injectable({ providedIn: 'root' })
export class CustomTitleStrategy extends TitleStrategy {
  private readonly titleService = inject(Title);
  private readonly appTitle = AppConsts.ApplicationName;
  constructor() {
    super();
  }
  updateTitle(routerState: RouterStateSnapshot): void {
    const pageTitle = this.buildTitle(routerState);
    if (pageTitle) {
      this.titleService.setTitle(`${this.appTitle} - ${pageTitle}`);
    } else {
      this.titleService.setTitle(this.appTitle);
    }
  }
}